import React from "react";

import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import { Link } from "react-router-dom";

import style from "./style.module.css";
import Background from "../../../components/Background";
import { landingJpg } from '../../../helpers/images';
import Center from "../../../components/Center";

export default function ExceptionScreen({ onClick = () => { } }) {
    return (
        <>
            <Header />
            <div className={style.noMatch}>
                <Background src={landingJpg} cdn={"static"} lazy={false} size={'1200x0'} />
                <div className={style.content}>
                    <Center>
                        <h1 className={style.title} align={"center"}>OOPS</h1>
                        <p className={style.subTitle}>Unexpected error! Please try again or contact support for assistance.</p>
                        <h4 className={style.text}><Link onClick={onClick} to={"/home"}>Go to Home</Link></h4>
                    </Center>
                </div>
            </div>
            <Footer />
        </>
    )
}